// extracted by mini-css-extract-plugin
export default {"container":"NavigationBubbles_container__bz10q","bubble":"NavigationBubbles_bubble__EXE3T","wide":"NavigationBubbles_wide__ZDNwj"};